import {createAsyncThunk} from '@reduxjs/toolkit';

import omit from '@tinkoff/utils/object/omit';

import type {AxiosError} from 'axios';

import type {AppDispatch} from 'stores/redux_store';
import {Client4} from 'mattermost-redux/client';
import {forceLogoutIfNecessaryThunkAxios} from 'mattermost-redux/actions/helpers';
import {type Profile} from '../types/profile';

export const putProfile = createAsyncThunk(
    'profiles/api/putProfile',
    async (payload: Profile, thunkAPI) => {
        const dispatch = thunkAPI.dispatch as AppDispatch;

        const requester = Client4.requester;

        const options = omit(['url'], Client4.getTimeApiClientOptions({}));

        const url = `${Client4.getUrl()}/api/v4/users/${payload.user_id}/profile`;

        try {
            const {data} = await requester.put<Profile>(url, payload, options);

            return data;
        } catch (e: unknown) {
            const error = e as AxiosError;

            dispatch(forceLogoutIfNecessaryThunkAxios(error));

            throw error;
        }
    },
);
